import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { format } from 'date-fns'

import { url } from "../../../services/constant";
import {
  Curve,
  CurveOverImage,
  NewBackButton,
  Phone,
  RightArrow,
  ChevronRightArrow,
  Time as TimeIcon,
  WinnersIcon,
  ProfileIcon,
} from "../../../components/svgs";
import {
  Body,
  Button,
  Children,
  CurveHolder,
  DynamicButton,
  MainHolder,
  StyledText,
} from "../../../components/common/basic";

import { BackButton } from "../../../components/common";
import { useTheme, useLoyalty } from "../../../hooks";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import useMashupnWinPoints from "./hooks/useMashupnWinPoints";

function ordinalOf(i) {
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return i + "st";
  }
  if (j == 2 && k != 12) {
    return i + "nd";
  }
  if (j == 3 && k != 13) {
    return i + "rd";
  }
  return i + "th";
};

const rankings = {
  alltime: [
    { msisdn: 'xxxx-xxx-651', points: 113272 },
    { msisdn: 'xxxx-xxx-452', points: 943543 },
    { msisdn: 'xxxx-xxx-433', points: 88272 },
    { msisdn: 'xxxx-xxx-776', points: 85332 },
    { msisdn: 'xxxx-xxx-926', points: 44876 },
    { msisdn: 'xxxx-xxx-547', points: 32113 },
    { msisdn: 'xxxx-xxx-025', points: 12356 },
    { msisdn: 'xxxx-xxx-452', points: 11465 },
    { msisdn: 'xxxx-xxx-256', points: 9342 },
    { msisdn: 'xxxx-xxx-632', points: 4946 },
  ],
  today: [
    { msisdn: 'xxxx-xxx-651', points: 500 },
    { msisdn: 'xxxx-xxx-776', points: 460 },
    { msisdn: 'xxxx-xxx-433', points: 440 },
    { msisdn: 'xxxx-xxx-452', points: 420 },
    { msisdn: 'xxxx-xxx-926', points: 410 },
    { msisdn: 'xxxx-xxx-025', points: 400 },
    { msisdn: 'xxxx-xxx-632', points: 380 },
    { msisdn: 'xxxx-xxx-256', points: 350 },
    { msisdn: 'xxxx-xxx-547', points: 320 },
    { msisdn: 'xxxx-xxx-452', points: 300 },
  ],
  you: {
    today: { rank: 30, points: 200 },
    alltime: { rank: 92, points: null },
  }
}

const PulseNChillLeaderboard = () => {
  const {
    background,
    history,
    userPoints,
  } = useMashupnWinPoints();

  useEffect(() => {
    analytics().then(anl => logEvent(anl, "screen_view", {
      firebase_screen: "MashupAndWinLeaderboard",
      firebase_screen_class: "MashupAndWinLeaderboard",
    }));
  }, []);

  const [isOn, toggleSwitchState] = useState(false);
  const [activeRankings, setActiveRankings] = useState([]);
  const [myRanking, setMyRanking] = useState({});

  useEffect(() => {
    if (isOn) {
      setActiveRankings(rankings.today);
      setMyRanking(rankings.you.today);
    } else {
      setActiveRankings(rankings.alltime);
      setMyRanking({ rank: rankings?.you?.alltime?.rank, points: userPoints });
    }
  }, [isOn, userPoints])

  return (
    <>
      <MainHolder style={{ background: "#F2F2F2" }}>
        <Children>
          <Header background={background}>
            <BackButton
              onClick={() => {
                history.goBack();
              }}
            />
            <div style={{ textAlign: 'center', marginBottom: '30px', }}>
              <StyledText style={{ fontFamily: 'MTNRegular' }} size={24} margin="0" color="white">Leaderboard</StyledText>
            </div>
            <BoxSwitch
              onLabel={'Today'}
              offLabel={'All time'}
              background={background}
              isOn={isOn}
              onToggle={toggleSwitchState}
            />
          </Header>
          <CurveHolder style={{ zIndex: 1, position: "relative" }}>
            <Curve fill={"#F2F2F2"} />
          </CurveHolder>
          <LargeRankCard
            background={background}
            points={myRanking?.points}
            rank={ordinalOf(myRanking.rank || 1)}
          />
          <Body>
            <div style={{ boxSizing: 'border-box', padding: '0 15px' }}>
              {
                activeRankings.map((rankData, index) => {
                  const rankFmt = ordinalOf(index + 1);
                  return <RankCard
                    background={background}
                    {...rankData}
                    rank={rankFmt}
                  />
                })
              }
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const BoxSwitch = ({ onLabel, offLabel, onToggle, background, isOn }) => {
  const buttonStyle = { flexGrow: 1, borderRadius: '5px', padding: '10px', textAlign: 'center', background: 'none' };
  const activeButtonStyle = { ...buttonStyle, background };
  return (
    <div
      onClick={() => onToggle(!isOn)}
      style={{
        cursor: 'pointer',
        fontFamily: 'MTNRegular',
        color: '#fff',
        display: 'flex',
        width: '230px',
        margin: '0 auto',
        borderRadius: '5px',
        fontSize: '12px',
        background: 'rgba(0,0,0,0.6)',
        padding: '3px',
      }}
    >
      <div style={isOn ? activeButtonStyle : buttonStyle}>{onLabel}</div>
      <div style={!isOn ? activeButtonStyle : buttonStyle}>{offLabel}</div>
    </div>
  );
};

const RankCard = ({ rank, msisdn, points, background }) => {
  const columnStyle = {
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
  };
  return (
    <div
      style={{
        padding: '8px 3px',
        borderRadius: '10px',
        background: '#fff',
        position: 'relative',
        display: 'flex',
        maxWidth: '325px',
        zIndex: 2,
        margin: '0 auto 10px auto',
      }}
    >
      <div style={{ ...columnStyle, width: '40px', }}>
        <StyledText margin={0} size={14} style={{ fontFamily: 'MTNBold' }}>{rank}</StyledText>
      </div>
      <div style={{ width: '50px', ...columnStyle }}>
        <div style={{
          width: '35px',
          background: '#fff',
          height: '35px',
          borderRadius: '100px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #000',
          overflow: 'hidden',
        }}>
          <ProfileIcon width={20} height={20} />
        </div>
      </div>
      <div style={{ flexGrow: 1, ...columnStyle }}>
        <StyledText margin={0} size={14} style={{ fontFamily: 'MTNBold' }}>{msisdn}</StyledText>
      </div>
      <div style={{ width: '85px', ...columnStyle }}>
        <StyledText color={background} margin={0} size={14} style={{ fontFamily: 'MTNBold' }}>{points?.toLocaleString()}pts</StyledText>
      </div>
    </div>
  )
}

const LargeRankCard = ({ background, points, rank }) => {
  return (
    <div
      style={{
        padding: '5px 3px',
        borderRadius: '10px',
        background: '#fff',
        margin: '20px auto -80px auto',
        position: 'relative',
        display: 'flex',
        boxShadow: '0 0 13px rgba(0,0,0,0.2)',
        width: '280px',
        top: '-90px',
        zIndex: 2,
      }}
    >
      <div style={{ width: '33%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <StyledText margin={0} size={10} style={{ fontFamily: 'MTNRegular' }}>Rank</StyledText>
        <StyledText margin={0} size={24} style={{ fontFamily: 'MTNBold' }}>{rank}</StyledText>
      </div>
      <div style={{ width: '34%' }}>
        <div style={{ textAlign: 'center', position: 'relative', top: '-15px', marginBottom: '-10px' }}>
          <div style={{
            width: '55px',
            background: '#fff',
            height: '55px',
            borderRadius: '100px',
            margin: '0 auto 5px auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #000',
            overflow: 'hidden',
          }}>
            <ProfileIcon width={20} height={20} />
          </div>
          <StyledText margin={0} size={12} style={{ fontFamily: 'MTNRegular' }}>big_freeze</StyledText>
          <StyledText margin={0} size={10} color={background} style={{ fontFamily: 'MTNRegular' }}>0244552821</StyledText>
        </div>
      </div>
      <div style={{ width: '33%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <StyledText margin={0} size={10} style={{ fontFamily: 'MTNRegular' }}>Points</StyledText>
        <StyledText margin={0} size={24} style={{ fontFamily: 'MTNBold' }}>{points?.toLocaleString()}</StyledText>
      </div>
    </div>
  )
};

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 80px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default PulseNChillLeaderboard;
